import { gql } from '@apollo/client'

export const GET_PICOS_AUDIT_STATS_FOR_STORE = gql`
  query PicOSAuditStatsForStore($storeId: ID!, $date: Date!) {
    picosAuditStatsForStore(storeId: $storeId, date: $date) {
      auditDate
      executeDenom
      executeNum
      sellDenom
      sellNum
      averageCompliance
      correctPricingPercentage
      numDisplaysWithOos
    }
  }
`
